module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/common/attributes-select-add/attributes-select-add.component.scss
// module id = ./src/app/modules/backstage-module/common/attributes-select-add/attributes-select-add.component.scss
// module chunks = 9